<div [class.bg-white]="isFullScreen" #elementFullScreen>
  <div mat-dialog-title>
    @if (isMobile) {
      <!-- Mobile Layout -->
      <div
        class="text-truncate d-flex justify-content-between align-items-center fs-6"
      >
        <span
          ><strong>
            {{
              fileName
                ? fileName.length > 32
                  ? (fileName | slice: 0 : 32) + "..."
                  : fileName
                : "N/A"
            }}.pdf
          </strong></span
        >
        <!-- Fechar -->
        <button mat-icon-button (click)="close()" matTooltip="Fechar">
          <i class="far fa-xmark"></i>
        </button>
      </div>
      <mat-toolbar
        color="primary"
        class="w-100 d-flex justify-content-between align-items-center"
      >
        <!-- Ferramentas -->
        <div class="d-flex align-items-center mx-auto">
          <!-- Navegação -->
          <button
            mat-icon-button
            (click)="prevPage()"
            matTooltip="Página anterior"
          >
            <i class="fal fa-arrow-left"></i>
          </button>
          <button
            mat-icon-button
            (click)="nextPage()"
            matTooltip="Próxima página"
          >
            <i class="fal fa-arrow-right"></i>
          </button>
          <!-- Zoom -->
          <button mat-icon-button (click)="zoomOut()" matTooltip="- Zoom">
            <i class="far fa-magnifying-glass-minus"></i>
          </button>
          <button mat-icon-button (click)="zoomIn()" matTooltip="+ Zoom">
            <i class="far fa-magnifying-glass-plus"></i>
          </button>
          <!-- Download -->
          @if (canDownload) {
            <button mat-icon-button (click)="download()" matTooltip="Download">
              <i class="far fa-download"></i>
            </button>
          }
        </div>
      </mat-toolbar>
    } @else {
      <div class="d-flex justify-content-between align-items-center">
        <!-- Título -->
        <div class="w-100">
          <span
            ><strong> {{ fileName }}.pdf </strong></span
          >
          <!-- Ferramentas no Desktop -->
          <div class="w-100 d-flex align-items-center">
            <nav style="font-size: small">
              <button
                type="button"
                mat-button
                (click)="prevPage()"
                matTooltip="Página anterior"
              >
                <i class="fal fa-arrow-left"></i>
              </button>
              <span class="d-none d-lg-inline-flex"
                >Pág. {{ pdfViewer?.pdfViewer?.currentPageNumber }} de
                {{ pdfViewer?.pdfViewer?.pagesCount }}</span
              >
              <button
                type="button"
                mat-button
                (click)="nextPage()"
                matTooltip="Próxima página"
              >
                <i class="fal fa-arrow-right"></i>
              </button>
            </nav>
            |
            <button
              mat-button
              style="font-size: small"
              (click)="zoomOut()"
              matTooltip="- Zoom"
            >
              <i class="far fa-magnifying-glass-minus"></i>
            </button>
            <div class="zoom-percentage pb-1" style="font-size: small">
              {{ (pdfZoom * 100).toFixed(0) }}%
            </div>
            <button
              mat-button
              style="font-size: small"
              (click)="zoomIn()"
              matTooltip="+ Zoom"
            >
              <i class="far fa-magnifying-glass-plus"></i>
            </button>
            |
            <button
              mat-button
              style="font-size: small"
              (click)="viewInFullScreen()"
              [matTooltip]="getFullScreenToolTip()"
            >
              <i
                [ngClass]="isFullScreen ? 'fas fa-compress' : 'fas fa-expand'"
              ></i>
            </button>
          </div>
        </div>
        <!-- Download / Fechar -->
        <div class="d-flex">
          @if (canDownload) {
            <button mat-icon-button (click)="download()" matTooltip="Download">
              <i class="far fa-download"></i>
            </button>
          }
          <button mat-icon-button (click)="close()" matTooltip="Fechar">
            <i class="far fa-xmark"></i>
          </button>
        </div>
      </div>
    }

    <!-- Desktop Layout -->
  </div>

  <mat-dialog-content>
    @if (!!pdfSource) {
      <!-- Doc: https://www.npmjs.com/package/ng2-pdf-viewer -->
      <pdf-viewer
        #pdfViewer
        [src]="pdfSource"
        [original-size]="true"
        [render-text]="false"
        [rotation]="0"
        [show-all]="true"
        [fit-to-page]="true"
        [zoom]="pdfZoom"
        [external-link-target]="'blank'"
        [zoom-scale]="zoomScaleOptions[currentZoomScaleIndex]"
        [autoresize]="false"
        [show-borders]="false"
        style="
          height: calc(100dvh - 128px);
          width: calc(100% - 48px);
          position: absolute;
          background-color: #e1e1e1;
        "
      >
      </pdf-viewer>
    } @else {
      <div class="position-relative h-100 text-center" style="overflow: auto">
        Não foi possível visualizar este arquivo.
      </div>
    }
  </mat-dialog-content>
</div>
